export default "__VITE_ASSET__CNTUpaaT__"